/**
 * Code-defined vocabulary for feature flag keys (FLIP-304), mirroring
 * BrainChanger.Domain.Models.FeatureFlagModels.FeatureFlagKeys on the API side. Keep the two in
 * sync by hand - there are only ever a handful of these, so a generated/shared source isn't
 * worth the build complexity yet.
 */
export const FeatureFlagKeys = {
  /** Gates the onboarding walkthrough as a whole (FLIP-6). Individual lessons are not separately flagged in this first pass. */
  OnboardingWalkthrough: "onboarding-walkthrough",
} as const;

export type FeatureFlagKey = (typeof FeatureFlagKeys)[keyof typeof FeatureFlagKeys];

/**
 * Resolved when the boot-time fetch fails (offline, API error, not yet loaded) - see
 * FeatureFlagService.isEnabled. Deliberately conservative (everything off) rather than mirroring
 * each flag's server-side default, since a client that can't reach the API also can't know
 * whether a kill switch was just flipped off for exactly this reason.
 */
export const FEATURE_FLAG_FALLBACK_DEFAULTS: Record<FeatureFlagKey, boolean> = {
  [FeatureFlagKeys.OnboardingWalkthrough]: false,
};
